module.exports = __webpack_public_path__ + "img/logo_ensenada.b04bfcfa.png";